import React, { useState, PropsWithChildren, ReactNode, Fragment, TdHTMLAttributes, useEffect } from 'react';
import { arrowClosedStyle, infoboxIconActStyle, infoboxIconStyle, ScrollToElem } from '../SubpageComponents';
import { RiskVariant, Insured } from '../../model/policy/AccidentPolicy';
import { Button } from 'react-bootstrap';
import { Button as MButton, Dialog, DialogTitle, DialogContent, DialogActions, useTheme, useMediaQuery } from '@material-ui/core';
import { Dots3Icon, ArrowTable, CovidIcon, InfoboxIcon } from '../svg/Icons';
import { VariantsTableMobile } from './VariantsTableMobile';
import useScrollPosition from '@react-hook/window-scroll';

export const arrowOpenIconStyle = { transform: 'rotate(180deg)', ...arrowClosedStyle, fill: 'var(--yellow-color)' };

export function VariantsTable(props: {
  onChange?: () => void,
  insured: Insured | undefined
})
{
  function choiceRows()
  {
    return (
      <>
        <SelectableRow
          className="premiumEx"
          rowNo={risksTable.length}
          renderCells={isSelected =>
          {
            return <>
              <HTD
                className="text-center premium" style={{ borderRight: 'none' }}
                varName="premiumNoExRowHeight"
                triggerUpdate={true}
              >
                <strong>
                  Składka roczna za osobę z rozszerzeniem <br />o wyczynowe uprawianie sportu
                </strong>
              </HTD>
              <td className="text-center amount premium" style={{ borderLeft: 'none', zIndex: 1 }}>
                <InfoboxIcon className="ml-2" style={isSelected ? infoboxIconActStyle : infoboxIconStyle} />
              </td>
              <td className="text-center amount premium">
                <strong>{premiumsSports[0]} PLN</strong>
                <br />
                <VariantButton variant={RiskVariant.Variant1} extremeSports={false} {...props} />
              </td>
              <td className="text-center amount  premium">
                <strong>{premiumsSports[1]} PLN</strong>
                <br />
                <VariantButton variant={RiskVariant.Variant2} extremeSports={false} {...props} />
              </td>
              <td className="text-center amount  premium">
                <strong>{premiumsSports[2]} PLN</strong>
                <br />
                <VariantButton variant={RiskVariant.Variant3} extremeSports={false} {...props} />
              </td>
            </>;
          }}
          expandedRow={
            <tr>
              <td colSpan={5} className="text-left description">
                <div style={{ maxWidth: 1024 }}>
                  <div className="text-justify">
                    Wyczynowe uprawianie sportu – forma aktywności fizycznej podejmowana w celu uzyskania, w drodze indywidualnej lub zbiorowej rywalizacji, maksymalnych wyników sportowych, polegająca na uprawianiu przez Ubezpieczonego sportu:
                  </div>
                  <div className="mt-3 ml-2 text-justify">
                    a) poprzez uczestniczenie w treningach, zawodach, zgrupowaniach i obozach kondycyjnych lub szkoleniowych w ramach pozaszkolnych klubów, związków i organizacji sportowych,
                  </div>
                  <div className="mt-2 ml-2 text-justify">
                    b) podczas zajęć wychowania fizycznego odbywających się w ramach obowiązującego planu lekcji w szkołach sportowych.
                  </div>
                </div>
              </td>
            </tr>
          }
        />

        <SelectableRow
          className="premiumEx"
          rowNo={risksTable.length + 1}
          renderCells={isSelected =>
          {
            return <>
              <HTD
                varName="premiumExRowHeight"
                className={`premium text-center`} style={{ borderRight: 'none' }}>
                <strong>
                  Składka roczna za osobę z rozszerzeniem <br /> o sporty i aktywności wysokiego ryzyka
                </strong>
              </HTD>
              <td className="text-center amount premium" style={{ borderLeft: 'none', zIndex: 1 }}>
                <InfoboxIcon className="ml-2" style={isSelected ? infoboxIconActStyle : infoboxIconStyle} />
              </td>
              <td className="text-center amount premium">
                <strong>{premiumsExtremeSports[0]} PLN</strong>
                <br />
                <VariantButton variant={RiskVariant.Variant1} extremeSports={true} {...props} />
              </td>
              <td className="text-center amount premium">
                <strong>{premiumsExtremeSports[1]} PLN</strong>
                <br />
                <VariantButton variant={RiskVariant.Variant2} extremeSports={true} {...props} />
              </td>
              <td className="text-center amount premium">
                <strong>{premiumsExtremeSports[2]} PLN</strong>
                <br />
                <VariantButton variant={RiskVariant.Variant3} extremeSports={true} {...props} />
              </td>
            </>;
          }}
          expandedRow={
            <tr>
              <td colSpan={5} className="text-left description">
                <div style={{ maxWidth: 1024 }}>
                  <div className="fw-600">
                    Sporty i aktywności wysokiego ryzyka włączone do ochrony ubezpieczeniowej
                  </div>
                  <div className="mt-3 text-justify">
                    Za zapłatą dodatkowej składki, zakres ubezpieczenia Ubezpieczonego może zostać rozszerzony na warunkach określonych w OWU o następstwa nieszczęśliwych wypadków doznane w związku z uprawianiem następujących sportów i aktywności wysokiego ryzyka: airsoft, taternictwo, trekking, nurkowanie ze sprzętem do głębokości 30 metrów poniżej poziomu morza, windsurfing, żegluga poza wodami terytorialnymi w odległości powyżej 12 mil morskich od brzegu, jazda na nartach wodnych, kitesurfing, kolarstwo górskie, jeździectwo, zorbing, strzelectwo sportowe.
                  </div>
                  <div className="fw-600 mt-4">
                    Sporty i aktywności wysokiego ryzyka wyłączone z ochrony ubezpieczeniowej
                  </div>
                  <div className="mt-3 text-justify">
                    highlining, slacklining, bouldering, wspinaczka skalna, wspinaczka lodowa, alpinizm, himalaizm, skialpinizm, zjazdy ekstremalne na nartach, freestyle, freeride, snowboarding wysokogórski, snowboarding prędkościowy, skoki i ewolucje narciarskie i snowboardowe, rafting, canyoning, hydrospeed, kajakarstwo górskie, szybownictwo, spadochroniarstwo, lotniarstwo, paralotniarstwo, motolotniarstwo, baloniarstwo, pilotowanie samolotów lub śmigłowców, skoki z/na bungee, nurkowanie powyżej głębokości 30m, parkour, freerun, buggykitting, jazda quadami, speedrower, kolarstwo ekstremalne, speleologia, bobsleje, saneczkarstwo, sporty motorowe, rajdy pojazdów lądowych, wodnych lub powietrznych, heliskiing, heliboarding, freefall, downhill, b.a.s.e. jumping, dream jumping oraz zjazdy na nartach lub snowboardzie poza wyznaczonymi trasami, skeleton, bojery, jazda skibobem oraz sporty, w których wykorzystywane są pojazdy przeznaczone do poruszania się po śniegu lub lodzie, Krav Maga, boks zawodowy, MMA, Ninjutsu, Muay Thai, Ju Jitsu, Sambo.
                  </div>
                </div>
              </td>
            </tr>
          }
        />
      </>
    );
  }

  return <>
    <div className="w-100  mt-4 mb-2 only-mobile mobile-center">
      Im wyższa suma ubezpieczenia, <br />
      <strong>tym wyższa wypłata odszkodowania</strong>
    </div>
    <VariantsTableMobile
      {...props}
    />
    <div className="w-100  mt-4 text-right only-desktop">
      Im wyższa suma ubezpieczenia, <br />
      <strong>tym wyższa wypłata odszkodowania</strong>
    </div>
    <div className="w-100  mb-2 only-desktop d-flex justify-content-end">
      <ArrowTable style={{ width: 16, height: 32.64, marginRight: 70 }} />
    </div>
    <div className={`tableBox position-relative stdColors only-desktop`}>
      <Dots3Icon style={{ position: 'absolute', top: '10%', width: 94, height: 333, left: '-100px' }} />
      <div className="tableContainer">
        <table className={`w-100 headerTab`}>
          <thead>
            <tr className="variantHeader">
              <td style={{ borderRight: 'none' }} />
              <td style={{ borderLeft: 'none', zIndex: 1 }} />
              <HTD
                varName="variantRowHeight"
                className="text-nowrap vtd">
                Wariant I
              </HTD>
              <td className="text-nowrap vtd">
                Wariant II
              </td>
              <td className="text-nowrap vtd">
                Wariant III
              </td>
            </tr>
            {choiceRows()}
            <tr className="scopeHeader">
              <td style={{ borderRight: 'none' }} >
                Rodzaj świadczenia
              </td>
              <td style={{ borderLeft: 'none', zIndex: 1 }} />
              <td colSpan={3}>
                Wysokość świadczenia (PLN)
              </td>
            </tr>
          </thead>
        </table>
        <table>
          <tbody>
            {risksTable.map((risk, idx) =>
            {
              return (
                <Fragment key={idx}>
                  <SelectableRow
                    rowNo={idx}
                    renderCells={isSelected => <>
                      <td
                        className={`text-left kind${risk.description ? ' cursor-pointer' : ''}`}
                        style={{ borderRight: 'none' }}
                      >
                        {risk.name}
                      </td>
                      <td
                        className={`text-left kind${risk.description ? ' cursor-pointer' : ''}`}
                        style={{ borderLeft: 'none' }}
                      >
                        {risk.description && <>
                          <InfoboxIcon className="ml-2" style={isSelected ? infoboxIconActStyle : infoboxIconStyle} />
                        </>}
                      </td>
                      <td className="text-right amount vtd">{risk.variant1}</td>
                      <td className="text-right amount vtd">{risk.variant2}</td>
                      <td className="text-right amount vtd">{risk.variant3}</td>
                    </>
                    }
                    expandedRow={
                      <>
                        {!!risk.description &&
                          <tr>
                            <td colSpan={5} className="text-left description">
                              {risk.description}
                            </td>
                          </tr>}

                      </>
                    }
                  />
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </>;
}

export function SelectableRow(props: PropsWithChildren<
  {
    className?: string;
    rowNo: number,
    renderCells: (isSelected: boolean) => ReactNode,
    expandedRow?: ReactNode,
    scrollToExpRow?: boolean;
    exRef?: any,
  }
>)
{
  const [isSelected, setSelected] = useState(false);

  return (
    <>
      <tr
        ref={props.exRef}
        id={`expRow${props.rowNo}`}
        onClick={() =>
        {
          setSelected(!isSelected);
          if (!isSelected)
          {
            ScrollToElem(`expRow${props.rowNo}`, 'center');
          }
        }}
        className={`${props.className} ${isSelected ? 'selected' : undefined}`}
      >{
          props.renderCells(isSelected)
        }
      </tr>
      {isSelected && props.expandedRow}
    </>);
}

export function VariantButton(props:
  {
    insured?: Insured,
    variant: RiskVariant,
    extremeSports: boolean,
    onChange?: (variant: RiskVariant) => void,
  })
{
  return (
    <>
      <Button
        id={'var' + props.variant + 'ex' + (props.extremeSports ? 'Yes' : 'No')}
        variant="primary"
        className="red mt-3"
        onClick={() =>
        {
          props.insured?.variant.setValue(props.variant);
          props.insured?.extremeSports.setValue(props.extremeSports);
          props.insured?.calculatePremium();
          if (props.onChange)
          {
            props.onChange(props.variant);
          }
        }}
      >
        Wybieram
      </Button>
    </>
  );
}

export function VariantsDialog(props:
  {
    open: boolean, close: () => void,
    insured: Insured,
  })
{

  useEffect(() =>
  {
    includeNavHeight = !props.open;
  }, [props.open]);

  const handleClose = () =>
  {
    props.close();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      maxWidth={'lg'}
      fullScreen={fullScreen}
    >
      <DialogTitle className="stdColors">Wybierz wariant ubezpieczenia</DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <VariantsTable
          insured={props.insured}
          onChange={() =>
          {
            handleClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <MButton id="varCancel" onClick={handleClose} color="primary">
          Anuluj
        </MButton>
      </DialogActions>
    </Dialog>
  );
}

export const sums = [20000, 32000, 54000];
export const premiumsSports = [50, 80, 120];
export const premiumsExtremeSports = [65, 100, 150];

export interface RiskInfo
{
  name: ReactNode,
  variant1: ReactNode,
  variant2: ReactNode,
  variant3: ReactNode,
  description?: ReactNode,
}

function makeRisk(percent: number, name: string, description?: ReactNode): RiskInfo
{
  return {
    name,
    variant1: formatCurrency(sums[0] * percent),
    variant2: formatCurrency(sums[1] * percent),
    variant3: formatCurrency(sums[2] * percent),
    description,
  };
}

// pasuje do cyfry pod warunkiem że po niej następuje jedna lub więcej grupy trzycyfrowe, a po nich koniec
const fmtRe = /(\d)(?=(\d{3})+$)/g;
const nbsp = '\xa0';

/**
 * Postać prezentacyjna kwoty
 * sep tysięcy    - nbsp
 * sep dziesiętny - kropka
 */
function formatCurrency(v: number): string
{
  const av = Math.abs(v);
  const w = av.toString().replace(fmtRe, '$1' + nbsp);
  return (v < 0 ? '-' : '') + w;
}

export const risksTable: RiskInfo[] = [
  makeRisk(1, 'Suma ubezpieczenia'),
  makeRisk(0.01, 'Uszczerbek na zdrowiu w wyniku NW (świadczenie za 1% uszczerbku)',
    'Naruszenie sprawności organizmu powstałe w następstwie nieszczęśliwego wypadku, polegające na trwałym, nierokującym poprawy w świetle aktualnego stanu wiedzy medycznej, uszkodzeniu danego organu, narządu lub układu. Uszczerbkiem na zdrowiu może być spowodowany  np. złamaniem ręki czy uszkodzeniem narządów wewnętrznych ciała.'),
  makeRisk(1, 'Śmierć Ubezpieczonego w wyniku NW',
    <>
      <div className="mb-3">
        W przypadku śmierci Ubezpieczonego w wyniku nieszczęśliwego wypadku Ubezpieczyciel wypłaci świadczenie w wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż:
      </div>
      <div className="mb-2 ml-2">
        a) nieszczęśliwy wypadek wydarzył się podczas trwania ochrony ubezpieczeniowej oraz
      </div>
      <div className="mb-2 ml-2">
        b) śmierć nastąpiła w ciągu dwóch lat od daty nieszczęśliwego wypadku.
      </div>
    </>
  ),
  makeRisk(2, 'Śmierć Ubezpieczonego w wyniku NW na terenie placówki oświatowej (świadczenie skumulowane ze świadczeniem Śmierć Ubezpieczonego w wyniku NW)',
    <>
      <div>
        W przypadku śmierci Ubezpieczonego w wyniku nieszczęśliwego wypadku na terenie placówki oświatowej Ubezpieczyciel wypłaci dodatkowe świadczenie w wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż:
      </div>
      <div className="mt-3 ml-2">
        a) nieszczęśliwy wypadek wydarzył się na terenie placówki oświatowej, której Ubezpieczony jest podopiecznym lub pracownikiem, podczas trwania ochrony ubezpieczeniowej,
      </div>
      <div className="mt-2 ml-2">
        b) śmierć nastąpiła w ciągu sześciu miesięcy od daty nieszczęśliwego wypadku oraz
      </div>
      <div className="mt-2 ml-2">
        c) zajście nieszczęśliwego wypadku zostało udokumentowane zaświadczeniem dyrektora placówki oświatowej.
      </div>
    </>
  ),
  {
    name: "koszty nabycia wyrobów medycznych wydawanych na zlecenie oraz koszty zakupu lub naprawy okularów korekcyjnych lub aparatu słuchowego uszkodzonych w wyniku NW na terenie placówki oświatowej",
    variant1: <>do 6 000 (aparaty, okulary do 200)</>,
    variant2: <>do 9 600 (aparaty, okulary do 200)</>,
    variant3: <>do 16 200 (aparaty, okulary do 200)</>,
    description:
      <>
        <div>
          Zwrot udokumentowanych kosztów nabycia wyrobów medycznych wydawanych na zlecenie  do wysokości 30% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem iż:
        </div>
        <div className="mt-3 ml-2">
          a) są niezbędne z medycznego punktu widzenia i udokumentowane kopią zlecenia lekarskiego na zaopatrzenie w wyroby medyczne wydawane na zlecenie oraz
        </div>
        <div className="mt-2 ml-2">
          b) zostały poniesione na terytorium Rzeczpospolitej Polskiej w okresie nie dłuższym niż dwa lata od daty nieszczęśliwego wypadku.
        </div>
        <div className="mt-3">
          Zwrot udokumentowanych kosztów zakupu lub naprawy okularów korekcyjnych lub aparatu słuchowego uszkodzonych w wyniku nieszczęśliwego wypadku na terenie placówki oświatowej  – do wysokości 200 zł, pod warunkiem że nieszczęśliwy wypadek, w wyniku którego doszło do uszkodzenia okularów korekcyjnych lub aparatu słuchowego miał miejsce na terenie placówki oświatowej.
        </div>
      </>,
  },
  {
    name: "koszty przekwalifikowania zawodowego osób niepełnosprawnych",
    variant1: <>do 6 000</>,
    variant2: <>do 9 600</>,
    variant3: <>do 16 200</>,
    description:
      <>
        <div>
          Zwrot udokumentowanych kosztów do wysokości 30% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem iż:
        </div>
        <div className="mt-3 ml-2">
          a) Ubezpieczonemu na podstawie decyzji Zakładu Ubezpieczeń Społecznych przyznano rentę szkoleniową jako osobie trwale niezdolnej do pracy w dotychczasowym zawodzie lub orzeczenie powiatowego (lub wojewódzkiego) zespołu ds. orzekania o niepełnosprawności, w którym orzeczono o celowości przekwalifikowania zawodowego osoby niepełnosprawnej oraz
        </div>
        <div className="mt-2 ml-2">
          b) zostały poniesione na terytorium Rzeczypospolitej Polskiej w okresie nie dłuższym niż dwa lata od daty nieszczęśliwego wypadku.
        </div>
      </>,
  },
  makeRisk(0.01, 'uszczerbek na zdrowiu w wyniku ataku padaczki', 'Jednorazowe świadczenie w wysokości 1% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż padaczka została rozpoznana po raz pierwszy w okresie trwania ochrony ubezpieczeniowej.'),
  makeRisk(0.2, 'Rozpoznanie u Ubezpieczonego sepsy', 'Jednorazowe świadczenie w wysokości 20% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż sepsa została rozpoznana po raz pierwszy w okresie trwania ochrony ubezpieczeniowej.'),
  makeRisk(0.1, 'Śmierć rodzica lub opiekuna prawnego Ubezpieczonego  w wyniku NW',
    <>
      <div>
        W przypadku śmierci opiekuna prawnego lub rodzica Ubezpieczonego w następstwie nieszczęśliwego wypadku – świadczenie w wysokości 10% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż:
      </div>
      <div className="mt-3 ml-2">
        a) nieszczęśliwy wypadek wydarzył się podczas trwania ochrony ubezpieczeniowej,
      </div>
      <div className="mt-2 ml-2">
        b) śmierć nastąpiła w ciągu 12 miesięcy od daty nieszczęśliwego wypadku.
      </div>
      <div className="mt-3">
        Odpowiedzialność InterRisk ograniczona jest do dwóch zdarzeń w okresie ubezpieczenia.
      </div>
    </>,
  ),
  makeRisk(0.01, 'Pogryzienie przez psa (bez wymogu pobytu w szpitalu)', 'Jednorazowe świadczenie w wysokości1% sumy ubezpieczenia określonej w umowie ubezpieczenia w przypadku pogryzienia'),
  makeRisk(0.02, 'Pokąsania, ukąszenia (wymóg pobytu w szpitalu 2 dni)', 'Jednorazowe świadczenie w wysokości 2 % sumy ubezpieczenia określonej w umowie ubezpieczenia w przypadku pokąsania, ukąszenia przez owady i inne zwierzęta niż psy pod warunkiem co najmniej dwudniowego pobytu w szpitalu w wyniku pokąsania, ukąszenia.'),
  makeRisk(0.01, 'Wstrząśnienie mózgu w wyniku NW (wymóg pobytu w szpitalu 3 dni)', 'Jeżeli w wyniku nieszczęśliwego wypadku Ubezpieczony doznał wstrząśnienia mózgu, w wyniku którego konieczny był co najmniej trzydniowy pobyt w szpitalu przysługuje jednorazowe świadczenie w wysokości stanowiącej 1% sumy ubezpieczenia określonej w umowie ubezpieczenia.'),
  makeRisk(0.05, 'zatrucie pokarmowe, nagłe zatrucie gazami bądź porażenie prądem lub piorunem (wymóg pobytu w szpitalu 3 dni)', 'Świadczenie w wysokości 5% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem co najmniej trzydniowego pobytu w szpitalu w wyniku zatrucia pokarmowego, nagłego zatrucia gazami, bądź w przypadku porażenia prądem lub piorunem.'),
  makeRisk(0.05, 'rozpoznanie u Ubezpieczonego chorób odzwierzęcych (bąblowicy, toksoplazmozy, wścieklizny)', 'Jednorazowe świadczenie w wysokości 5% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż bąblowica, toksoplazmoza lub wścieklizna zostały rozpoznane w okresie trwania ochrony ubezpieczeniowej.'),
  {
    name: 'Śmierć Ubezpieczonego w następstwie wypadku komunikacyjnego',
    description:
      <>
        <div>
          Świadczenie w wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D1, pod warunkiem, iż:
        </div>
        <div className="mt-3 ml-2">
          a) wypadek komunikacyjny wydarzył się podczas trwania ochrony ubezpieczeniowej oraz
        </div>
        <div className="mt-2 ml-2">
          b) śmierć nastąpiła w ciągu dwóch lat od daty nieszczęśliwego wypadku.
        </div>
        <div className="mt-3">
          Wypadek komunikacyjny  jest rozumiany jako  nagłe zdarzenie wywołane ruchem pojazdu (wyłącznie samochód osobowy, samochód ciężarowy, autobus, pociąg, tramwaj, trolejbus, metro), na skutek którego zmarł Ubezpieczony, będący pasażerem pojazdu, pieszym lub osobą kierującą pojazdem.
          (Opcja Dodatkowa D1)
        </div>
      </>,
    variant1: '20 000',
    variant2: '32 000',
    variant3: '50 000'
  },
  {
    name: 'pobyt w szpitalu w wyniku NW (płatny od 1 dnia pobytu, wymóg pobytu w szpitalu 2 dni)',
    variant1: '45 / dzień',
    variant2: '60 / dzień',
    variant3: '80 / dzień',
    description: 'Świadczenie w wysokości 1% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D4, za każdy dzień pobytu w szpitalu, począwszy od pierwszego dnia pobytu w szpitalu, będącego następstwem nieszczęśliwego wypadku, który miał miejsce w okresie trwania ochrony ubezpieczeniowej, pod warunkiem pobytu w szpitalu trwającego minimum 2 dni. Świadczenie z tytułu pobytu w szpitalu w wyniku nieszczęśliwego wypadku przysługuje maksymalnie za 100 dni pobytu w szpitalu. Gdy wypis ze szpitala nastąpi po zakończeniu okresu ubezpieczenia pobyt w szpitalu jest objęty odpowiedzialnością Ubezpieczyciela, pod warunkiem, że przyjęcie do szpitala nastąpiło w okresie ubezpieczenia. (Opcja Dodatkowa D4)'
  },
  {
    name: <>pobyt w szpitalu w wyniku choroby (płatny od 2 dnia pobytu, wymóg pobytu w szpitalu 3 dni) <span style={{ color: 'var(--red-color)' }}>
      <CovidIcon style={{ width: 30, height: 'auto', fill: 'var(--red-color)' }} /> Obejmuje zachorowanie na Covid-19

    </span></>,
    variant1: '35 / dzień',
    variant2: '50 / dzień',
    variant3: '70 / dzień',
    description: 'świadczenie w wysokości 1% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D5, za każdy następny dzień pobytu w szpitalu, począwszy od drugiego dnia pobytu w szpitalu, w związku z chorobą, która została rozpoznana w trakcie trwania ochrony ubezpieczeniowej, pod warunkiem pobytu Ubezpieczonego w szpitalu trwającego minimum 3 dni. W przypadku kolejnych, następujących po sobie pobytów w szpitalu w związku z tą samą chorobą świadczenie szpitalne przysługuje od pierwszego dnia pobytu w szpitalu. Świadczenie z tytułu pobytu w szpitalu w wyniku choroby przysługuje maksymalnie za 100 dni pobytu w szpitalu. Gdy wypis ze szpitala nastąpi po zakończeniu okresu ubezpieczenia pobyt w szpitalu jest objęty odpowiedzialnością Ubezpieczyciela, pod warunkiem, że przyjęcie do szpitala nastąpiło w okresie ubezpieczenia. (Opcja Dodatkowa D5)'
  },
  {
    name: 'Poważne choroby',
    variant1: '1 000',
    variant2: '2 500',
    variant3: '4 000',
    description:
      <>
        <div>
          Świadczenie w wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D6, pod warunkiem rozpoznania u Ubezpieczonego po raz pierwszy w okresie trwania ochrony ubezpieczeniowej, następującego rodzaju Poważnej Choroby:
        </div>
        <div className="mt-3 ml-2">
          a) nowotwór złośliwy,
        </div>
        <div className="mt-2 ml-2">
          b) paraliż,
        </div>
        <div className="mt-2 ml-2">
          c) niewydolność nerek,
        </div>
        <div className="mt-2 ml-2">
          d) transplantacja głównych organów,
        </div>
        <div className="mt-2 ml-2">
          e) poliomyelitis,
        </div>
        <div className="mt-2 ml-2">
          f) utrata mowy,
        </div>
        <div className="mt-2 ml-2">
          g) utrata słuchu,
        </div>
        <div className="mt-2 ml-2">
          h) utrata wzroku,
        </div>
        <div className="mt-2 ml-2">
          i) anemia aplastyczna,
        </div>
        <div className="mt-2 ml-2">
          j) stwardnienie rozsiane,
        </div>
        <div className="mt-2 ml-2">
          k) cukrzyca typu I,
        </div>
        <div className="mt-2 ml-2">
          l) niewydolność serca,
        </div>
        <div className="mt-2 ml-2">
          m) choroba autoimmunologiczna,
        </div>
        <div className="mt-2 ml-2">
          n) zapalenie opon mózgowo-rdzeniowych.
        </div>
        <div className="mt-3">
          (Opcja Dodatkowa D6)
        </div>
      </>
  },
  {
    name: 'operacje w wyniku nieszczęśliwego wypadku',
    variant1: 'do 3 000',
    variant2: 'do 4 000',
    variant3: 'do 6 000',
    description:
      <>
        <div>
          Świadczenie w wysokości stanowiącej procent sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D8, uzależnione od rodzaju operacji określonej wyłącznie w TABELI nr 8 OWU, pod warunkiem iż operacja:
        </div>
        <div className="mt-3 ml-2">
          a)została zalecona przez lekarza jako niezbędna część procesu leczenia następstw nieszczęśliwego
          wypadku, który miał miejsce w okresie trwania ochrony ubezpieczeniowej oraz
        </div>
        <div className="mt-2 ml-2">
          b) została przeprowadzona w trakcie trwania ochrony ubezpieczeniowej w trakcie co
          najmniej trzydniowego pobytu w szpitalu,
        </div>
        <div className="mt-3">
          (Opcja Dodatkowa D8)
        </div>
      </>
  },
  {
    name: 'operacje plastyczne w wyniku nieszczęśliwego wypadku',
    variant1: 'do 2 000',
    variant2: 'do 3 000',
    variant3: 'do 4 000',
    description:
      <>
        <div>
          Koszty operacji plastycznych w wyniku nieszczęśliwego wypadku – zwrot udokumentowanych kosztów do wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia, pod warunkiem, iż:
        </div>
        <div className="mt-3 ml-2">
          a) operacja plastyczna została zalecona przez lekarza jako niezbędna część procesu leczenia następstw nieszczęśliwego wypadku, który miał miejsce w trakcie trwania ochrony ubezpieczeniowej oraz
        </div>
        <div className="mt-2 ml-2">
          b) koszty operacji plastycznej zostały poniesione w okresie nie dłuższym niż jeden rok od daty nieszczęśliwego wypadku;
        </div>
      </>
  },
  {
    name: 'operacje w wyniku choroby',
    variant1: 'do 3 000',
    variant2: 'do 4 000',
    variant3: 'do 6 000',
    description:
      <>
        <div>
          Świadczenie w wysokości stanowiącej procent sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D9, uzależnione od rodzaju operacji, określonej wyłącznie w TABELI nr 9 OWU, pod warunkiem iż operacja:
        </div>
        <div className="mt-3 ml-2">
          a) została zalecona przez lekarza jako niezbędna część procesu leczenia choroby, która została rozpoznana po raz pierwszy w okresie ubezpieczenia oraz
        </div>
        <div className="mt-2 ml-2">
          b) została przeprowadzona w trakcie trwania okresu ubezpieczenia w trakcie co najmniej trzydniowego pobytu w szpitalu;
        </div>
        <div className="mt-2 ml-2">
          c) jeżeli w wyniku tej samej choroby zostanie wykonana więcej niż jedna operacja, przysługuje – zgodnie z TABELĄ nr 9 OWU – świadczenie będące sumą kwot za każdy rodzaj operacji, ale wysokość świadczenia nie może przekroczyć sumy ubezpieczenia ustalonej w umowie ubezpieczenia dla Opcji Dodatkowej D9.        </div>
        <div className="mt-3">
          (Opcja Dodatkowa D9)
        </div>
      </>
  },
  {
    name: 'koszty leczenia (w tym rehabilitacja do 1 000 zł)',
    variant1: 'do 1 000',
    variant2: 'do 2 000',
    variant3: 'do 2 500',
    description:
      <>
        <div>
          Zwrot udokumentowanych kosztów do wysokości 100% sumy ubezpieczenia określonej w umowie
          ubezpieczenia dla Opcji Dodatkowej D10. W ramach limitu na zwrot kosztów leczenia zastosowanie
          ma podlimit na zwrot kosztów rehabilitacji, który wynosi 1.000 zł. Zwrot kosztów leczenia następuje pod warunkiem, że koszty leczenia:
        </div>
        <div className="mt-3 ml-2">
          a) powstały w następstwie nieszczęśliwego wypadku, który wydarzył się podczas trwania ochrony ubezpieczeniowej oraz
        </div>
        <div className="mt-2 ml-2">
          b) zostały poniesione w okresie nie dłuższym niż 12 miesięcy od daty nieszczęśliwego wypadku.
        </div>
        <div className="mt-3">
          (Opcja Dodatkowa D10)
        </div>
      </>
  },
  {
    name: 'koszty leczenia stomatologicznego',
    variant1: 'do 1 000',
    variant2: 'do 1 500',
    variant3: 'do 2 000',
    description:
      <>
        <div>
          Zwrot udokumentowanych kosztów do wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D13, ale nie więcej niż 300 zł za jeden ząb, pod warunkiem, iż koszty leczenia stomatologicznego:
        </div>
        <div className="mt-3 ml-2">
          a) powstały w następstwie nieszczęśliwego wypadku, który wydarzył się podczas trwania ochrony ubezpieczeniowej oraz
        </div>
        <div className="mt-2 ml-2">
          b) zostały poniesione na odbudowę stomatologiczną uszkodzonego lub utraconego zęba stałego, z zastrzeżeniem, że w związku z utratą lub uszkodzeniem zęba w następstwie nieszczęśliwego wypadku u Ubezpieczonego został orzeczony uszczerbek na zdrowiu lub trwałe inwalidztwo częściowe oraz
        </div>
        <div className="mt-2 ml-2">
          c) zostały poniesione w okresie ubezpieczenia na terytorium Rzeczpospolitej Polskiej, w okresie maksymalnie 6 miesięcy od daty nieszczęśliwego wypadku.
        </div>
        <div className="mt-3">
          (Opcja Dodatkowa D13)
        </div>
      </>
  },
  {
    name: 'Uciążliwe leczenie',
    variant1: '100',
    variant2: '200',
    variant3: '300',
    description:
      <>
        <div>
          wypłata świadczenia w wysokości 100% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D14, pod warunkiem, iż:
        </div>
        <div className="mt-3 ml-2">
          a) nieszczęśliwy wypadek nie pozostawił uszczerbku na zdrowiu Ubezpieczonego (0% uszczerbku na zdrowiu), bądź trwałego inwalidztwa częściowego, złamania kości, ran ciętych lub szarpanych, urazów narządów ruchu, wstrząśnienia mózgu oraz
        </div>
        <div className="mt-2 ml-2">
          b) przebieg leczenia spowodował czasową niezdolność Ubezpieczonego do nauki lub do pracy przez okres nie krótszy niż 10 dni.
        </div>
        <div className="mt-3">
          (Opcja Dodatkowa D14)
        </div>
      </>
  },
  {
    name: 'Opieka nad dzieckiem przebywającym w szpitalu (płatny od 1 dnia pobytu, wymóg pobytu w szpitalu 3 dni)',
    variant1: <div className="text-center">–</div>,
    variant2: <div className="text-center">–</div>,
    variant3: '50 / dzień',
    description: 'W przypadku pobytu w szpitalu, w wyniku wypadku komunikacyjnego lub Poważnej Choroby, Ubezpieczonego, który nie ukończył 14 roku życia – świadczenie dzienne w wysokości 1% sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D24, płatne za każdy dzień opieki rodzica Ubezpieczonego lub opiekuna prawnego nad Ubezpieczonym o ile pobyt w szpitalu trwa co najmniej 3 dni. Świadczenie przysługuje maksymalnie za 15 dni opieki nad Ubezpieczonym w trakcie pobytu w szpitalu. Świadczenie wypłacane jest pod warunkiem, że pobyt w szpitalu był następstwem wypadku komunikacyjnego, który wydarzył się podczas trwania ochrony ubezpieczeniowej lub Poważnej Choroby, która została rozpoznana po raz pierwszy w trakcie trwania ochrony ubezpieczeniowej. (Opcja Dodatkowa D24)'
  },
  {
    name: 'Oparzenia w wyniku NNW (II,III, IV stopień)',
    variant1: <span>300 <br /> 900<br /> 1 500</span>,
    variant2: <span>300 <br /> 900<br /> 1 500</span>,
    variant3: <span>300 <br /> 900<br /> 1 500</span>,
    description: 'Świadczenie w wysokości stanowiącej procent sumy ubezpieczenia określonej w umowie ubezpieczenia dla Opcji Dodatkowej D2, uzależnione od stopnia oparzenia określonego wyłącznie w TABELI nr 6 OWU. (Opcja Dodatkowa D2)'
  },
  {
    name: 'Pakiet Kleszcz',
    variant1: 'do 1 500',
    variant2: 'do 1 500',
    variant3: 'do 1 500',
    description:
      <>
        <div>
          Pakiet KLESZCZ i rozpoznanie boreliozy – jednorazowe świadczenie w wysokości 1.000 PLN w przypadku ukąszenia Ubezpieczonego przez kleszcza i rozpoznania u Ubezpieczonego boreliozy. Ukąszenie Ubezpieczonego przez kleszcza oraz rozpoznanie u Ubezpieczonego boreliozy muszą nastąpić w okresie trwania ochrony ubezpieczeniowej.
        </div>
        <div className="mt-2">
          Ponadto InterRisk pokryje udokumentowane koszty:
        </div>
        <div className="mt-3 ml-2">
          a) wizyty u lekarza w celu usunięcia wkłutego kleszcza do wysokości 150 PLN,
        </div>
        <div className="mt-2 ml-2">
          b) badań diagnostycznych, których celem jest potwierdzenie lub wykluczenie zakażenia boreliozą, zaleconych przez lekarza po ukąszeniu przez kleszcza do wysokości 150 PLN,
        </div>
        <div className="mt-2 ml-2">
          c) antybiotykoterapii zaleconej przez lekarza (tj. antybiotyku zakupionego z recepty otrzymanej od lekarza), której celem jest leczenie boreliozy spowodowanej ukąszeniem przez kleszcza do wysokości 200PLN, o ile koszty te zostały poniesione na terytorium Rzeczypospolitej Polskiej w okresie 6 miesięcy od dnia ukąszenia przez kleszcza oraz nie zostały sfinansowane ze środków publicznych.
        </div>
      </>
  },
  {
    name: 'HEJT STOP',
    variant1: 'do 5 000',
    variant2: 'do 5 000',
    variant3: 'do 5 000',
    description:
      <>
        <div>
          Usługi wsparcia informatycznego, psychologicznego i prawnego dla dorosłych i dzieci, w zakresie mowy nienawiści i bezpieczeństwa w sieci.
        </div>
        <div className="mt-2">
          Pomoc IT – usunięcie lub zablokowanie przez informatyka dostępu do negatywnych, obraźliwych lub bezprawnie udostępnionych informacji o Ubezpieczonym (zabezpieczenie i/lub wsparcie w usunięciu treści), a także w miarę możliwości identyfikacja sprawcy.
        </div>
        <div className="mt-2">
          Pomoc prawna – pomoc dotycząca sposobu postepowania w przypadku niepożądanego zdarzenia w sieci, zabezpieczenie dowodów, wsparcie prawne Ubezpieczonego w zgłoszeniu zdarzenia na Policję, w procesie interwencji, w dochodzeniu odszkodowania od sprawcy, sporządzaniu aktów prawnych i wniosków o zablokowanie treści.
        </div>
        <div className="mt-2">
          Pomoc psychologiczna – konsultacje zdalne realizowane przez specjalistów.
        </div>
      </>
  },
  {
    name: 'Ochrona w trakcie uprawiania sportów wyczynowych',
    variant1: <div>tak</div>,
    variant2: <div>tak</div>,
    variant3: <div>tak</div>,
    description:
      <>
        <div>
          Forma aktywności fizycznej podejmowana w celu uzyskania, w drodze indywidualnej lub zbiorowej rywalizacji, maksymalnych wyników sportowych, polegająca na uprawianiu przez Ubezpieczonego sportu:
        </div>
        <div className="mt-3 ml-2">
          a) poprzez uczestniczenie w treningach, zawodach, zgrupowaniach i obozach kondycyjnych lub szkoleniowych w ramach pozaszkolnych klubów, związków i organizacji sportowych,
        </div>
        <div className="mt-2 ml-2">
          b) podczas zajęć wychowania fizycznego odbywających się w ramach obowiązującego planu lekcji w szkołach sportowych,
        </div>
        <div className="mt-3">
          W rozumieniu OWU za wyczynowe uprawianie sportu nie uważa się aktywności fizycznej
          Ubezpieczonego polegającej na:
        </div>
        <div className="mt-3 ml-2">
          a) uczestniczeniu w treningach, zawodach, zgrupowaniach i obozach kondycyjnych lub szkoleniowych w ramach szkolnych (uczniowskich) klubów sportowych,
        </div>
        <div className="mt-2 ml-2">
          b) uprawianiu sportu podczas zajęć wychowania fizycznego (również w klasach sportowych) odbywających się w ramach obowiązującego planu lekcji, za wyjątkiem sytuacji, gdy Ubezpieczony jest uczniem szkoły sportowej,
        </div>
        <div className="mt-2 ml-2">
          c) udziale Ubezpieczonego w zawodach wewnątrzszkolnych lub międzyszkolnych, za wyjątkiem sytuacji, gdy Ubezpieczony jest uczniem szkoły sportowej,
        </div>
        <div className="mt-2 ml-2">
          d) rekreacyjnym uprawianiu sportu.
        </div>
      </>
  },
];

const rowHeights = new Map<string, HTMLElement>();
let includeNavHeight = true;

function HTD(props: PropsWithChildren<TdHTMLAttributes<any> & { varName: string, triggerUpdate?: boolean }>)
{

  const scrollPos = useScrollPosition();
  if (scrollPos > 68 && props.triggerUpdate)
  {
    updateHeights();
  }

  const { varName, ...rest } = props;
  const ts = useTopSetter(varName);
  return <td {...ts} {...rest} />;
}

export function useTopSetter(varName: string)
{
  return {
    ref: (r: any) =>
    {
      if (r)
      {
        rowHeights.set(varName, r);
        updateHeights();
      }
    }
  };
}

function rowHeightsget(name: string)
{
  const elem = rowHeights.get(name);
  return elem?.offsetHeight;
}

function updateHeights()
{
  const root = document.documentElement;
  const navHeight = includeNavHeight ? rowHeightsget('navHeight') ?? 0 : 0;
  const variantRowHeight = rowHeightsget('variantRowHeight') ?? 0;
  const premiumNoExRowHeight = rowHeightsget('premiumNoExRowHeight') ?? 0;
  const premiumExRowHeight = rowHeightsget('premiumExRowHeight') ?? 0;
  root.style.setProperty('--variantHeaderTop', `${navHeight}px`);
  root.style.setProperty('--premiumNoExTop', `${navHeight + variantRowHeight - 1}px`);
  root.style.setProperty('--premiumExTop', `${navHeight + variantRowHeight + premiumNoExRowHeight - 2}px`);
  root.style.setProperty('--scopeTop', `${navHeight + variantRowHeight + premiumNoExRowHeight + premiumExRowHeight - 3}px`);

}
